export class ModalData {
    addConfigData = {
        state: false,
        backdrop: true,
        title: "Add Configuration",
        subTitle: "Fill in the details",
        cancelButton: "Cancel",
        okButton: "Add",
        cancelBClass: "btn-outline",
        okBClass: "btn-primary",
        elements: [
            {
                type: "select",
                label: "Category",
                options: [
                    "Select",
                    "Compute Maximum",
                    "ESXi Host Maximum",
                    "Virtual Volumes",
                    "Storage Maximum",
                    "Network Maximum"
                ],
                selectedValue: ""
            },
            {
                type: "text",
                label: "Config",
                size: 45,
                placeHolder: "Enter value here",
                selectedValue: "",
                options: []
            },

            {
                type: "text",
                label: "Config Value",
                size: 45,
                placeHolder: "Enter value here",
                selectedValue: "",
                options: []

            },
            {
                type: "text",
                label: "Performance Member",
                size: 45,
                placeHolder: "Enter value here",
                selectedValue: "",
                options: []

            },
            {
                type: "text",
                label: "QE Member",
                size: 45,
                placeHolder: "Enter value here",
                selectedValue: "",
                options: []
            },
            {
                type: "text",
                label: "Product Manager",
                size: 45,
                placeHolder: "Enter value here",
                selectedValue: "",
                options: []
            },
            {
                type: "text",
                label: "Dev Member",
                size: 45,
                placeHolder: "Enter value here",
                selectedValue: "",
                options: []
            },
            {
                type: "textarea",
                label: "Comment",
                size: 5,
                placeHolder: "Add comment",
                selectedValue: "",
                options: []
            }
        ]
    };

    public dataHeaders: any = [
        {
            name: "Item",
            class: "moreWidth",
            filter: "itemFilter",
        },
        {
            name: "Previous Version",
            class: ""
        },
        {
            name: "PMT",
            class: ""
        },
        {
            name: "Target",
            class: ""
        },
        {
            name: "Test Plan",
            class: ""
        },
        {
            name: "Publish",
            class: ""
        },
        {
            name: "Comment",
            class: ""
        }
    ];

    public modalProps: any = {
        state: false,
        backdrop: true,
        title: "Delete Configuration",
        bodyContent: "Are you Sure ?",
        cancelButton: "Cancel",
        okButton: "Delete",
        cancelBClass: "btn-outline",
        okBClass: "btn-danger"
    };

    public chatModalProps: any = {
        state: false,
        backdrop: true,
        hasCommentAccess: true,
        cancelButton: "Cancel",
        submitButton: "Submit",
        cancelBClass: "btn-outline",
        submitBClass: "btn-success",
        commentPlaceHolder: "Add Comment",
        conversations: [
            {
                alertClass: "alert-success",
                user: "Kranti",
                message: "Please correct the value"
            },
            {
                alertClass: "alert-warning",
                user: "Someone",
                message: "This Value may not scale"
            }
        ]
    };

    public assignTeamMemberData: any = {
        state: false,
        backdrop: true,
        title: "Assign team member",
        cancelButton: "Cancel",
        okButton: "Assign",
        cancelBClass: "btn-outline",
        okBClass: "btn-primary",
        size: 'md',
        elements: [
            {
                type: "text",
                label: "Email",
                size: 45,
                placeHolder: "Enter Team member email here",
                selectedValue: ""
            }
        ]
    };

    public importConfigData: any = {
        state: false,
        backdrop: true,
        title: "Import Configuration",
        subTitle: "Select a xsl/csv file to upload",
        cancelButton: "Cancel",
        okButton: "Upload",
        cancelBClass: "btn-outline",
        okBClass: "btn-primary",
        size: 'md',
        elements: [
            {
                type: "file"
            }
        ]
    };

    public createMaximumData: any = {
        state: false,
        backdrop: true,
        title: "Create Maximum Category",
        subTitle: "Fill in the details",
        cancelButton: "Cancel",
        okButton: "Create",
        cancelBClass: "btn-outline",
        okBClass: "btn-primary",
        elements: [
            {
                type: "select",
                label: "Product",
                options: [
                    "Select",
                    "vSphere",
                    "vCenter",
                    "NSX"
                ],
                selectedValue: "Select"
            },
            {
                type: "select",
                label: "Version",
                options: [
                    "Select",
                    "6.5 U1",
                    "6.5",
                    "6.0",
                    "5.5"
                ],
                selectedValue: "Select"
            },
            {
                type: "text",
                label: "New Maximum Category",
                size: 45,
                placeHolder: "Enter value here",
                selectedValue: ""
            },
            {
                type: "textarea",
                label: "Comment",
                size: 5,
                placeHolder: "Add comment",
                selectedValue: ""
            }
        ]
    };

    mylabel: string;
}



// WEBPACK FOOTER //
// ./src/app/models/modaldata.ts